import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "profile-big",
  "use": "profile-big-usage",
  "viewBox": "0 0 30 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 32\" id=\"profile-big\">\n  <path fill-rule=\"evenodd\" d=\"M324.188,309.6A12.6,12.6,0,0,0,326,303c0-6.076-4.029-11-9-11s-9,4.924-9,11a12.606,12.606,0,0,0,1.811,6.6C305.16,311.806,302,316.079,302,321v1a2,2,0,0,0,2,2h26a2,2,0,0,0,2-2v-1C332,316.079,328.84,311.806,324.188,309.6ZM317,295c3.252,0,6,3.663,6,8s-2.748,8-6,8-6-3.664-6-8S313.748,295,317,295Zm-12,26c0-3.969,2.79-7.4,6.82-9.014a7.668,7.668,0,0,0,10.36,0C326.21,313.6,329,317.031,329,321H305Z\" transform=\"translate(-302 -292)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/profile-big.svg
// module id = null
// module chunks = 